export const presetsListTheme = {
  base: {
    borderColor: 'palette.neutral.40',
    borderRadius: '8px',
    borderWidth: '2px',
  },
  selected: {
    borderColor: 'palette.tertiary.80',
    borderRadius: '8px',
    borderWidth: '4px',
  },
};
